var a = { exports: {} };
export {
  a as __module
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/_virtual/dayjs.min.js
// module id = 1184
// module chunks = 67